<template>
    <div> 
		<div v-if="tradingAccountList.totalRecords > 0">
			<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && authComponent && transaction_id != '' && !congModuleLev)">
				<app-twofa  :call_from="request_page"></app-twofa>
			</div>
			<div v-else>
				<div class="mainTitle text-center mt-4 mb-3"> 
					<h3 class="mb-4">{{$t('changeLeverage')}}</h3>
					<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
					<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
				</div> 
				<!--loader - message--->
				
				<!-------------------->
				<div class="CustomBlockWidth inMiddle-area whitebox p-4" > 
					<div class="justify-content-center">  
							<!------------------request form------------------------->
							<div class="partcipate-fund" v-if="transaction_id == '' && !congModuleLev">
								<div class="form-group field-wrapper">
									<account-id></account-id>
								</div>
								
								<div class="form-group field-wrapper dob" v-if="exsisting_leverage != ''">
									<input type="text" v-model="exsisting_leverage"  name="lev" class="float-field "  readonly />
									<label for="password" class="float-label">{{$t('exsistLev')}}</label>
								</div>

								
								<div class="form-group field-wrapper change-leverage-select-field">
									<select class="mdb-select md-form float-field form-control change-leverage-field" v-model="leverage" v-validate="'required'" name="New Leverage"  :class="(leverage != ''?'active' :'') || ({ 'is-invalid': submitted && errors.has('New Leverage') })" ref="leverageInput">
										
										<option :value="key"  :disabled="(parseInt(get_user.pro_user) == 0) && (parseInt(demo_live) == 1)" v-html="$t('pro'+key)" v-for="(list,key) in leverageJsonPLCountry" v-if="getUserProfile.residence_country == 'PL' && exsisting_leverage != key"></option>

										<option :value="key" :disabled="(parseInt(get_user.pro_user) == 0) && (parseInt(demo_live) == 1)" v-html="$t('pro'+key)" v-for="(list,key) in leverageJson" v-if="getUserProfile.residence_country != 'PL' && exsisting_leverage != key"></option>
										
									</select>
									<label for="password" class="float-label">{{$t('newLev')}}</label>
									<ul><li v-for="error in errors.collect('New Leverage')">{{ error }}</li></ul>
								</div>

								<div class="form-group text-center field-wrapper" v-if="parseInt(get_user.pro_user) == 0">
									<p class="mb-3">{{$t('highleverage')}} <a href="#" @click="verifyStatus(get_user.verified_status)">{{$t('Clickhere')}}</a></p>
									 <!-- <p class="mb-3" v-else-if="parseInt(get_user.verified_status) == 0">{{$t('waitver')}}</p> -->

								</div> 
							 
								<div class="form-group text-center field-wrapper">
									<button class="prism_btn btn_sm" v-on:click="submitChangeLeverageRequestOtp()">{{$t('changeLeverage')}}</button>
								</div> 
								<div class="signupbtn mt-4 text-center" v-if="come_from_manage_page">
									<router-link :to="'/account-list'" class="underline">{{$t('backManageAccount')}}</router-link>
								</div>
								<div class="clearfix"></div>
							</div>
							<!----------------------------------------------------->
							<div class="partcipate-fund" v-if="transaction_id != '' && !congModuleLev">
								<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 1)">
									<p class="mb-3 text-center">{{$t('googleAuth1')}} <strong>{{$t('googleAuth2')}}</strong> {{$t('googleAuth3')}}. </p>
									<div class="form-group field-wrapper">
										<input type="text" placeholder="000 000" class="mdb-select md-form form-control" v-model="otp" v-validate="{ required: true, max: 6,numeric : true }" name="otp"  :class="{ 'is-invalid': submittedOtp && errors.has('otp') }" ref="otpInput">
										<ul><li v-for="error in errors.collect('otp')">{{ error }}</li></ul>
									</div> 
									<div class="form-group text-center field-wrapper">
										<button class="prism_btn btn_sm " v-on:click="submitChangeLeverageCheckOtp()">{{$t('validate')}} </button>
									</div>
									<div class="clearfix"></div>
									<div class="d-flex align-items-center justify-content-between border-top pt-3 mt-3"> 
										<div class="desc text-center">
											<p>{{$t('googleAuth4')}} <a v-on:click="resendLink()" href="#"><strong>{{$t('googleAuth5')}}</strong></a></p>
										</div>
									</div>
									<div class="clearfix"></div>
								</div>
								<div class="middleBox1"  v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && !authComponent)">
									<div class="congratulations">
										<div class="logo_congrats">
											<img src="../../../../static/fxView/images/leverage.svg" alt="Icon">
										</div>
										<div class="subtitle">
											<p class="mb-3">{{$t('dear')}} <strong class="green">{{get_user.username}}</strong>,
											</p>
											{{$t('googleAuth6')}} <strong>{{get_user.email}}. </strong> {{$t('levMsz1')}}
											<a v-on:click="resendLink()" href="#" class="mb-3"><strong>{{$t('googleAuth7')}}</strong></a>
										</div>
									</div>
									<div class="clearfix"></div>
									<div class="d-flex align-items-center justify-content-between enble2fa border-top pt-3 mt-3">
										<div class="ico mr-3">
											<img src="../../../../static/fxView/images/google_auth.png" alt="2fa">
										</div>
										<div class="desc w-75">
											<h5 class="mb-2"><strong>{{$t('googleAuth8')}}</strong></h5>
											<p>{{$t('googleAuth9')}} <a v-on:click="authComponent = true" href="#"><strong>{{$t('googleAuth10')}}</strong></a></p>
										</div>
									</div>
								</div>
							</div>
							<!---------------------congo-message-------------->
							<div class="stepForm" v-if="congModuleLev">
								<div class="congratulations">
									<div class="logo_congrats">
										<img src="../../../../static/fxView/images/check.svg" alt="Icon">
									</div>
									<div class="subtitle">
										<h3>{{$t('congo')}} <span class="green">{{get_user.username}}</span></h3>
										<p>{{$t('levMsz2')}}</p>
										<ul class="includeWdth">
											<li><strong>{{$t('tradingId')}}</strong> {{account_id}}</li>
											<li><strong>{{$t('oldLev')}}</strong>-</li>
											<li><strong>{{$t('newLev')}}</strong>{{leverage}}</li>
										</ul>
									</div>
									<div class="signupbtn full-width submitButton w-100 mt-4 text-center">
										<router-link :to="'/account-list'" class="prism_btn btn_sm">{{$t('goBackMangeAcc')}}</router-link>
									</div>
								</div> 
							</div>
					</div>
				</div>    
			</div>
		</div>
		<div v-else-if="tradingAccountList.totalRecords == 0">
            <div class="mainTitle  text-center my-3">
                <h3>{{$t('noDemoLiveTradingAccFound')}}</h3> 
            </div>
            <no-trading-account :demo_live_both="'yes'"></no-trading-account>
        </div>
		<div v-else class="text-center p-5 customLoader"> 
			<div class="loader"></div>  
            <h4>{{$t('plzWaitWhileProc')}}</h4>
        </div>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import twoFa from '../users/2FA'
    export default {
        name: 'Change-Leverage', 
        mixins: [fxViewMixins],
        data() {
            return {
				pageName : this.$options.name,
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                //==========================================
                come_from_manage_page : false,
				//-----select account----
                exsisting_leverage : '',
				selectAccount : false,
                account_id : '',
				act_account_id : '',
				demo_live : '',
				platform :'', 
				//------------------------

                leverage : '',
                submitted : false,

                otp : '',
                submittedOtp : false,
                transaction_id : '',

                congModuleLev : false,
                authComponent : false,
                request_page : 'accounts',

            }
        },
        methods:{
            resendLink(){
                let input_json = {
                    'globalParams' : {
                        'trans_id' : this.transaction_id.toString()
                    } ,'localParams' : {'parameter' : this}
                }
                this._runResendEmailLinkAccount(input_json)
            },
            verifyStatus(getstatus){
            	if(getstatus){
            		if(parseInt(getstatus) >= 1){
            			this.$router.push('/pro')
            		}else{
            			this.response_msg ="Please wait for the Verification."
            			this.msg_type = "error"
            		}

            	}

            },
            //================leverage===================================
            submitChangeLeverageRequestOtp(){
                const _that = this
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
								'act_account_id': _that.act_account_id,
                                'account_id' : _that.account_id ,
                                "leverage" : _that.leverage,
                                'operation' : 'CHANGE LEVERAGE'
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runAccountPasswordRequestOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            submitChangeLeverageCheckOtp(){
                const _that = this
                this.submittedOtp = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'google_token' : _that.otp.toString() ,
                                'trans_id' : _that.transaction_id.toString()
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runAccountLeverageCheckOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            reset(){
                this.account_id = ''
				this.act_account_id = ''
                this.leverage = ''
				this.demo_live = ''
				this.platform = ''
                this.submitted = false
            }
        },
        components: {
            appTwofa: twoFa
        },
        created(){
            if(this.$route.params.account_id){
                this.come_from_manage_page = true
                this.account_id = this.$route.params.account_id
				this.act_account_id = this.$route.params.act_account_id
                this.exsisting_leverage = this.$route.params.leverage
				this.demo_live = this.$route.params.demo_live
				this.platform = this.$route.params.platform
            }
			this._runGetTradingAccountList({'globalParams' : {} ,'localParams' : {'parameter' : this}})
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/manageAccounts/change_leverage.vue